import React from "react";
import Logo from "@assets/images/logo.png";
import ReviewerFaces from "./ReviewerFaces";
import "./auth.css";

/**
 * Shared shell for every auth screen: the form column on the left with
 * the brand mark above it, and a full-bleed photo panel on the right
 * carrying the marketing line. The photo panel is decorative and drops
 * out below 992px so the form gets the whole width.
 */
const SparkleIcon = () => (
  <svg
    className="auth-media-sparkle"
    width="44"
    height="44"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Main central white 4-pointed star */}
    <path
      d="M24 6 C24 16.5 17.5 24 7 24 C17.5 24 24 31.5 24 42 C24 31.5 30.5 24 41 24 C30.5 24 24 16.5 24 6 Z"
      fill="#FFFFFF"
    />
    {/* Top-left small golden star */}
    <path
      d="M10 5 C10 8.5 8 10.5 5 10.5 C8 10.5 10 12.5 10 16 C10 12.5 12 10.5 15 10.5 C12 10.5 10 8.5 10 5 Z"
      fill="#F5A524"
    />
    {/* Top-right mini golden star */}
    <path
      d="M38 8 C38 10.5 36 12 34 12 C36 12 38 13.5 38 16 C38 13.5 40 12 42 12 C40 12 38 10.5 38 8 Z"
      fill="#F5A524"
    />
  </svg>
);

const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="auth-shell">
    <main className="auth-main">
      <div className="auth-mark">
        <img src={ Logo } alt="The Smile Correct" />
      </div>

      <div className="auth-card">
        <h1 className="auth-title">{ title }</h1>
        { subtitle && <p className="auth-subtitle">{ subtitle }</p> }

        { children }

        { footer && <div className="auth-footer">{ footer }</div> }
      </div>

      <p className="auth-copyright">© The Smile Correct { new Date().getFullYear() }</p>
    </main>

    <aside className="auth-media">
      <div className="auth-media-inner">
        <SparkleIcon />

        <h2>
          Straighten your smile<br className="auth-media-br" />with confidence.
        </h2>
        <p>
          Start your clear aligner journey today and achieve the smile you’ve
          always wanted. Comfortable, invisible, and designed for your lifestyle
        </p>

        <div className="auth-media-rating">
          <ReviewerFaces />

          <div className="auth-media-score">
            <div className="auth-media-stars-row">
              <span className="auth-media-stars" aria-label="5 stars">
                { [0, 1, 2, 3, 4].map((i) => (
                  <svg
                    key={ i }
                    className="auth-media-star"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                )) }
              </span>
              <span className="auth-media-grade">5.0</span>
            </div>
            <span className="auth-media-count">from 200+ reviews</span>
          </div>
        </div>
      </div>
    </aside>
  </div>
);

export default AuthLayout;
